module.exports = __webpack_public_path__ + "static/banner_3-5eca6b18069c04454140f85c5544a4e3.jpg";